import PropTypes from 'prop-types';
import { sideNavFlags as sideNavConstant } from '@constants/index';
import useSidenavFlags from '@api/hooks/useSidenavFlags';
import AskADoubt from '@cont/Doubts20/AskADoubt';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import {
  useBookCatalogue,
  usePYQCatalogue
} from '@api/hooks/doubts-and-solutions/useCatalogs';
import solutionCatalog from '@models/SolutionCatalog';
import TopBlock from './TopBlock';
import CatalogTypeBlocks from './CatalogTypeBlock';

const CatalogueTypeHome = ({ goalUID }) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const { bookCatalogues: solutionCatalogBooks } = useBookCatalogue(goalUID);
  const { pyqCatalogues: solutionCatalogPYQs } = usePYQCatalogue(goalUID);
  const { goalInfo: goalData } = useGoalInfo(goalUID);
  const { sidenavFlags } = useSidenavFlags(goalUID);
  const AADFlags =
    sidenavFlags?.features?.find?.(
      (ele) => ele.type === sideNavConstant.DOUBTS_AND_SOLUTIONS
    ) || {};

  const { isAskADoubtEnabled, isDoubtsBrowseEnabled } = AADFlags;

  const renderCatalogueTypeBlock = (ctlgBlock) => {
    return (
      <CatalogTypeBlocks
        ctlgTypeData={ctlgBlock}
        key={ctlgBlock.uid}
        goalUID={goalUID}
        goalData={goalData}
      />
    );
  };
  const solutionCatalogTypes = {
    prev: null,
    next: null,
    isFetching: false,
    results: [
      { sectionTitle: 'Textbook solutions', type: 'text_book', data: [] },
      { sectionTitle: 'Previous year papers', type: 'papers', data: [] }
    ]
  };

  solutionCatalogTypes.results[0].data = solutionCatalogBooks.map((catlog) =>
    solutionCatalog.getEntityData(catlog)
  );
  solutionCatalogTypes.results[1].data = solutionCatalogPYQs.map((catlog) =>
    solutionCatalog.getEntityData(catlog)
  );

  return (
    <>
      <TopBlock goalUID={goalUID} />
      {!isLoggedIn || isAskADoubtEnabled ? (
        <AskADoubt goalUID={goalUID} />
      ) : null}
      {!isLoggedIn || isDoubtsBrowseEnabled
        ? solutionCatalogTypes.results.map((catalogue) =>
            renderCatalogueTypeBlock(catalogue)
          )
        : null}
    </>
  );
};

export default CatalogueTypeHome;

CatalogueTypeHome.propTypes = {
  goalUID: PropTypes.string.isRequired
};
